import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import Button from '../../../../global/atoms/button/index.js';
import GlobalModal from '../../../../global/atoms/globalModal/GlobalModal.js';
import { getJoinAccountData } from '../../utils/cashflowUtils.js';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents.js';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../../constants/analyticsConstants/Ecommerce.js';
import InfoIcon24 from '../../../../../resources/images/alert-yellow-circle.svg';
import { VerificationTimeOutTestId } from '../../../GRTestId.js';
import { ENV_CONFIG } from '../../../../../constants/envConfig.js';
import { AEM_CONTAINS_PHONE_NUMBER, JOIN_ACCOUNT_ERROR_SCREEN } from '../../../constants.js';
import './JoinCashVerificationFailedModal.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../../../global/utils/commonUtils.js';

const JoinCashVerificationFailedModal = ({ failedModal, hideFailedModal }) => {
    const { screenConfig = {} } = getJoinAccountData() || {};
    const { failedWarningTitle = '', failedWarningDescription = '', ctaLabelFailed = '' } = screenConfig || {};
    const { HELP_SUPPORT_MODAL_SECONDARY_BUTTON_PHONE_NUMBER_LABEL: phoneNumberLabel } = ENV_CONFIG || {};
    const [verificationContent = '', verificationContact = ''] =
        failedWarningDescription.split(AEM_CONTAINS_PHONE_NUMBER) || [];
    const { sendEventsForGRModalOpened, sendEventsForGRModalCompleted } = useAnalyticsContext();
    const phoneNumber = convertPhoneNumberAsPerSbmChannel(phoneNumberLabel);

    const navigateToErrorScreen = () => {
        hideFailedModal();
        window.onbeforeunload = null;
        window.location.href = JOIN_ACCOUNT_ERROR_SCREEN;
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_FAILED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            ctaLabelFailed
        );
    };

    const failedVerificationTitle = () => {
        return (
            <>
                <InfoIcon24 tabIndex={'-1'} aria-hidden={true} />
                <span>{failedWarningTitle}</span>
            </>
        );
    };

    useEffect(() => {
        if (failedModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_VERIFICATION_FAILED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        }
    }, []);

    const failedVerificationContent = () => {
        return (
            <>
                {verificationContent}{' '}
                <a href={`tel:${phoneNumber}`} data-testid={VerificationTimeOutTestId.MODAL_DESCRIPTION}>
                    <strong>{verificationContact}</strong>
                </a>
                <div className="helpmodal__actions">
                    {ctaLabelFailed && (
                        <Button
                            dataTestid={VerificationTimeOutTestId.RESEND_BUTTON}
                            tabIndex={0}
                            buttonAriaLabel={ctaLabelFailed}
                            className={`button button-primary button-block`}
                            onClick={navigateToErrorScreen}>
                            {ctaLabelFailed}
                        </Button>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <GlobalModal
                titleClasses={'failed-modal_title'}
                className={'width-327'}
                isOpen={failedModal}
                onRequestClose={hideFailedModal}
                title={failedVerificationTitle()}
                content={failedVerificationContent()}
                handleClose={hideFailedModal}
            />
        </>
    );
};

export default memo(JoinCashVerificationFailedModal);

JoinCashVerificationFailedModal.propTypes = {
    failedModal: propTypes.bool,
    hideFailedModal: propTypes.func
};
